import { render, staticRenderFns } from "./zwyVisitSetting.vue?vue&type=template&id=1fee4da6&scoped=true&"
import script from "./zwyVisitSetting.vue?vue&type=script&lang=js&"
export * from "./zwyVisitSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fee4da6",
  null
  
)

export default component.exports